import React, { useEffect } from 'react';

const Unauthorized = () => {
    useEffect(() => {
        // Clear specific elements from localStorage
        localStorage.removeItem('CC_Token');
        localStorage.removeItem('user');
    }, []); // Runs once when the component mounts

    return (
        <div className="container">
            <h1>403</h1>
            <p>Unauthorized Access</p>
            <p>Sorry, you don't have permission to access this page.</p>
            <a href="/login">Go to Login</a>
        </div>
    );
};

export default Unauthorized;
